import React, { useState, useEffect } from 'react';
import { Box, Typography, Tooltip } from '@mui/material';
import BackButton from './BackButton';

function ActivityLayout({ 
  title, 
  onBack, 
  timeLimit = null, 
  globalTimeLimit = null,
  score = 0, 
  onTimeUp, 
  onGlobalTimeUp,
  children, 
  isPaused = false 
}) {
  const [localTimer, setLocalTimer] = useState(timeLimit);
  const [globalTimer, setGlobalTimer] = useState(globalTimeLimit);

  // Local timer effect
  useEffect(() => {
    if (!timeLimit) return; // Don't start timer if timeLimit is null
    if (localTimer <= 0) {
      if (onTimeUp) onTimeUp();
      return;
    }
    
    if (isPaused) return;
    
    const interval = setInterval(() => setLocalTimer((prev) => prev - 1), 1000);
    return () => clearInterval(interval);
  }, [localTimer, onTimeUp, isPaused, timeLimit]);

  // Global timer effect
  useEffect(() => {
    if (!globalTimeLimit) return; // Don't start timer if globalTimeLimit is null
    if (globalTimer <= 0) {
      if (onGlobalTimeUp) onGlobalTimeUp();
      return;
    }
    
    if (isPaused) return;
    
    const interval = setInterval(() => setGlobalTimer((prev) => prev - 1), 1000);
    return () => clearInterval(interval);
  }, [globalTimer, onGlobalTimeUp, isPaused, globalTimeLimit]);

  // Reset local timer when timeLimit changes
  useEffect(() => {
    setLocalTimer(timeLimit);
  }, [timeLimit]);

 

  return (
    <Box
      sx={{
        userSelect: 'none',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        p: 2,
      }}
    >
      {/* Bottom Bar - Back Button, Timers, Score */}
      <Box
        sx={{
          width: '100%',
          borderRadius: '50px',
          display: 'flex',
          alignItems: 'center',
          p: 1,
          mt: 'auto',
          backgroundColor: '#f8f8f8',
        }}
      >
        {/* Left section - Back Button */}
        <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-start' }}>
          <BackButton onBack={onBack} />
        </Box>

        {/* Center section - Timers */}
        <Box sx={{ 
          flex: 2, 
          display: 'flex', 
          justifyContent: 'center', 
          gap: 3,
          alignItems: 'center' 
        }}>
          {timeLimit !== null && (
            <Tooltip title="Question Timer">
              <Typography 
                variant="h7" 
                sx={{ 
                  color: isPaused ? 'text.disabled' : localTimer <= 10 ? 'error.main' : 'text.primary',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 0.5,
                  fontWeight: 'bold'
                }}
              >
                ⏳ {localTimer}s
              </Typography>
            </Tooltip>
          )}
          {globalTimeLimit !== null && (
            <Tooltip title="Session Timer">
              <Typography 
                variant="h7" 
                sx={{ 
                  color: isPaused ? 'text.disabled' : globalTimer <= 30 ? 'error.main' : 'text.primary',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 0.5
                }}
              >
                ⌛ {globalTimer}s
              </Typography>
            </Tooltip>
          )}
        </Box>

        {/* Right section - Score */}
        <Box sx={{ flex: 1, textAlign: 'right' }}>
          <Typography variant="h7">⭐ Score: {score}</Typography>
        </Box>
      </Box>

      {/* Activity Content */}
      <Box sx={{ width: '100%', textAlign: 'center' }}>{children}</Box>
    </Box>
  );
}

export default ActivityLayout;
